(function () {
  "use strict";

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === "function") {
      return window.theme.formatMoney(cents);
    }
    var amount = Number(cents);
    if (!isFinite(amount)) return "";
    return "£" + (amount / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function likedHandles() {
    if (!window.TheArtfolioReactions) return [];
    var reactions = window.TheArtfolioReactions.getAllReactions() || {};
    var handles = Object.keys(reactions).filter(function (id) {
      return reactions[id] === "like" && id && !/^\d+$/.test(id);
    });
    if (window.TheArtfolioTaste && typeof window.TheArtfolioTaste.rankHandles === "function") {
      return window.TheArtfolioTaste.rankHandles(handles);
    }
    return handles.reverse();
  }

  function productImage(raw) {
    var image = "";
    if (raw.featured_image) {
      image = typeof raw.featured_image === "string"
        ? raw.featured_image
        : (raw.featured_image.src || "");
    } else if (raw.images && raw.images[0]) {
      image = typeof raw.images[0] === "string" ? raw.images[0] : (raw.images[0].src || "");
    }
    if (image.indexOf("//") === 0) image = "https:" + image;
    return image;
  }

  function fetchProduct(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin"
    }).then(function (response) {
      if (!response.ok) throw new Error("missing");
      return response.json();
    });
  }

  function initCarousel(section) {
    var track = section.querySelector("[data-taste-track]");
    var prev = section.querySelector("[data-taste-prev]");
    var next = section.querySelector("[data-taste-next]");
    if (!track || !prev || !next) return function () {};

    function slideAmount() {
      var slide = track.querySelector(".taste-shelf-slide");
      if (!slide) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 22;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.onclick = function () {
      track.scrollBy({ left: -slideAmount(), behavior: "smooth" });
    };
    next.onclick = function () {
      track.scrollBy({ left: slideAmount(), behavior: "smooth" });
    };
    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
    return updateButtons;
  }

  function cardHtml(product, discoverBase) {
    var handle = product.handle;
    var url = "/products/" + encodeURIComponent(handle);
    var image = productImage(product);
    var price = product.price_min != null ? product.price_min : product.price;
    var priceLabel = price != null ? "from " + formatMoney(price) : "";
    var remixUrl = discoverBase + (discoverBase.indexOf("?") > -1 ? "&" : "?") +
      "dsource=liked&product=" + encodeURIComponent(handle);
    var ph = image
      ? '<div class="ph" style="background-image:url(\'' + escapeHtml(image) + '\')"></div>'
      : '<div class="ph a a-oat"></div>';

    return (
      '<div class="journal-carousel-slide featured-carousel-slide taste-shelf-slide" role="listitem">' +
        '<a class="card" href="' + escapeHtml(url) + '">' +
          ph +
          '<div class="m">Liked</div>' +
          '<div class="t">' + escapeHtml(product.title || "Untitled") + "</div>" +
          (product.vendor ? '<div class="ar">' + escapeHtml(product.vendor) + "</div>" : "") +
          (priceLabel ? '<div class="p">' + escapeHtml(priceLabel) + "</div>" : "") +
        "</a>" +
        '<a class="taste-shelf-remix" href="' + escapeHtml(remixUrl) + '">Remix this</a>' +
      "</div>"
    );
  }

  function initTasteShelf(section) {
    var track = section.querySelector("[data-taste-track]");
    var discoverLink = section.querySelector("[data-taste-discover]");
    if (!track) return;

    var minLikes = Math.max(1, parseInt(section.getAttribute("data-min-likes"), 10) || 2);
    var maxItems = Math.max(1, parseInt(section.getAttribute("data-max-items"), 10) || 8);
    var discoverBase = section.getAttribute("data-discover-url") || "/pages/discover";
    var requestNumber = 0;
    var updateButtons = initCarousel(section);

    if (discoverLink) {
      discoverLink.href = discoverBase +
        (discoverBase.indexOf("?") > -1 ? "&" : "?") +
        "dsource=liked";
    }

    function setVisible(show) {
      section.hidden = !show;
      var shopifySection = section.closest(".shopify-section");
      if (shopifySection) shopifySection.hidden = !show;
    }

    function render() {
      var handles = likedHandles();
      if (handles.length < minLikes) {
        track.innerHTML = "";
        setVisible(false);
        return;
      }

      var thisRequest = ++requestNumber;
      var pending = handles.slice(0, maxItems);
      var remaining = pending.length;
      var products = new Array(pending.length);

      if (!remaining) {
        setVisible(false);
        return;
      }

      pending.forEach(function (handle, index) {
        fetchProduct(handle).then(function (raw) {
          if (thisRequest !== requestNumber) return;
          products[index] = raw;
        }).catch(function () {
          // Skip deleted / unavailable handles.
        }).then(function () {
          if (thisRequest !== requestNumber) return;
          remaining -= 1;
          if (remaining > 0) return;
          var ready = products.filter(Boolean);
          if (ready.length < minLikes) {
            track.innerHTML = "";
            setVisible(false);
            return;
          }
          track.innerHTML = ready.map(function (product) {
            return cardHtml(product, discoverBase);
          }).join("");
          setVisible(true);
          if (typeof updateButtons === "function") updateButtons();
        });
      });
    }

    render();
    document.addEventListener("theartfolio:reactionchange", render);
  }

  function boot() {
    document.querySelectorAll("[data-taste-shelf]").forEach(initTasteShelf);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
